import { render, staticRenderFns } from "./qianchuan.vue?vue&type=template&id=71a9ccc2&scoped=true"
import script from "./qianchuan.vue?vue&type=script&lang=js"
export * from "./qianchuan.vue?vue&type=script&lang=js"
import style0 from "./qianchuan.vue?vue&type=style&index=0&id=71a9ccc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9ccc2",
  null
  
)

export default component.exports